import { Trans, useLingui } from '@lingui/react';
import { scrollNextField } from '../../../helpers/scrollNextField';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarleadWhyChoose = () => {
  const {
    i18n
  } = useLingui();
  const title = i18n._('carlead.whyChoose.headline');
  const ctaLabel = i18n._('carlead.whyChoose.button.label');
  const handleScroll = () => {
    scrollNextField();
  };
  return /*#__PURE__*/_jsx("div", {
    className: "box gap white",
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("section", {
        className: "why-choose",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "section-title",
          children: title
        }), /*#__PURE__*/_jsx("div", {
          className: "row",
          children: /*#__PURE__*/_jsx(Trans, {
            id: 'carlead.whyChoose.list',
            message: 'carlead.whyChoose.list',
            components: {
              0: /*#__PURE__*/_jsx("div", {
                className: "why-choose__item col-md-6"
              }),
              // eslint-disable-next-line jsx-a11y/heading-has-content -- Lingui <Trans> fills this slot with the translated text at runtime
              1: /*#__PURE__*/_jsx("h4", {
                className: "why-choose__item-title"
              }),
              2: /*#__PURE__*/_jsx("p", {})
            }
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "row justify-content-center",
          children: /*#__PURE__*/_jsxs("button", {
            className: "btn btn-secondary btn-lg btn-arrow goToNextField",
            onClick: handleScroll,
            "data-tracking": "true",
            "data-action": "Click",
            "data-label": "CTA - Why Choose",
            children: [ctaLabel, /*#__PURE__*/_jsx("svg", {
              className: "svg-icon ml-2",
              xmlns: "http://www.w3.org/2000/svg",
              width: "1em",
              height: "1em",
              viewBox: "0 0 32 32",
              children: /*#__PURE__*/_jsx("path", {
                d: "m23.999 18 2-2-16-16L6 3.999 17.998 16 6 28.001 9.999 32l14-14z"
              })
            })]
          })
        })]
      })
    })
  });
};
export default CarleadWhyChoose;